import { connect } from 'react-redux';
import _ from 'lodash';
import { isExperimentEnabled } from '../selectors/experiments-selectors';

const mapStateToProps = config => state => _.mapValues(config, path => isExperimentEnabled(state, path));

export default function withExperiment(config) {
  return WrappedComponent => connect(mapStateToProps(config), {})(WrappedComponent);
}



// WEBPACK FOOTER //
// ./app/hoc/with-experiment.js